import FormMenu from "atoms/FormMenu";
import ValidatedInput from "atoms/ValidatedInput";
import { VStack } from "native-base";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AmplitudeHelper from "utils/analytics";
import { setValueGroups, setgPayDates } from "./gPayDatesUtils";

const GroupAndPayDateRender = ({
  formikErrors = {},
  errors = {},
  values = {},
  hasPendingUpdateRequest = false,
  handleChange = () => {},
  setFieldValue = () => {},
  setValues = () => {},
  isUpdate = false,
  groupPayDates = {},
}) => {
  const { t } = useTranslation("common");

  const [groupData, setGroupData] = useState([]);
  const [payDateData, setPayDateData] = useState([]);
  const payDate = values?.payDate ?? "";

  useEffect(() => {
    setgPayDates(setValues, values, groupPayDates, setGroupData, setPayDateData, setFieldValue, t);
  }, [groupPayDates]);

  useEffect(() => {
    setValueGroups(groupPayDates, values, setPayDateData, setFieldValue);
  }, [values?.group]);

  let formattedGroupName = values?.group ?? "";
  const formattedPayDate = values?.payDate === "-1" ? t("home.list.rows.endMonth") : payDate;

  if (groupData.length === 0 && !values?.group) {
    formattedGroupName = t("employeeCreation.single.noGroup");
  }

  return (
    <VStack space={2} minW="50%">
      <ValidatedInput
        testID="groupData"
        label="group"
        errors={{ ...formikErrors, ...errors }}
        disabled={groupData.length === 0 || hasPendingUpdateRequest}
        title="employeeCreation.single.group"
        isUpdate
        placeholder={t("employeeCreation.single.selectGroup")}
        value={formattedGroupName}
        setValue={handleChange("group")}
        amplitude="group_name"
        component={
          groupData.length > 0 ? (
            <FormMenu
              isDisabled={hasPendingUpdateRequest}
              data={groupData}
              placeholder={t("employeeCreation.single.selectGroup")}
              searchPlaceholder={t("employeeCreation.single.selectGroupPlaceholder")}
              shouldShowSearch
              value={formattedGroupName}
              setValue={(x) => setFieldValue("group", x)}
              isError={Object.prototype.hasOwnProperty.call({ ...formikErrors, ...errors }, "group")}
              amplitude="group_name"
            />
          ) : null
        }
      />
      <ValidatedInput
        errors={{ ...formikErrors, ...errors }}
        title="employeeCreation.single.payDate"
        label="payDate"
        required
        amplitude="salary_date"
        disabled={(!isUpdate ? payDateData.length <= 1 : payDateData.length === 0) || hasPendingUpdateRequest}
        value={isUpdate ? formattedPayDate : values?.payDate === "-1" ? t("home.list.rows.endMonth") : values?.payDate}
        component={
          payDateData.length > 1 || (isUpdate && payDateData.length !== 0) ? (
            <FormMenu
              isDisabled={hasPendingUpdateRequest}
              data={payDateData}
              placeholder={t("employeeCreation.single.selectDate")}
              isError={Object.prototype.hasOwnProperty.call({ ...formikErrors, ...errors }, "payDate")}
              isUpdate={isUpdate}
              isPayDateSection
              value={isUpdate ? formattedPayDate : values?.payDate}
              setValue={(x) => {
                AmplitudeHelper.logEvent("salary_date_chosen", {
                  source: isUpdate ? "single_employee_update_page" : "single_employee_creation_page",
                  input: x,
                });
                setFieldValue("payDate", x);
              }}
              amplitude="salary_date"
            />
          ) : null
        }
      />
    </VStack>
  );
};

export default GroupAndPayDateRender;
